export default __webpack_public_path__ + "static/media/bike-8.3c0523c3.svg";